// extracted by mini-css-extract-plugin
export default {"container":"g0WgOj","pill":"phMz67","active":"KZHZuC"};